import { PieChartData } from "@evergis/charts";

import { FEATURE_CARD_DEFAULT_COLORS, FEATURE_CARD_OTHER_COLOR } from "../constants";
import { i18n } from "../../../i18n";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";
import { ConfigContainerChild } from "../types";

export const getDataFromAttributes = (
  config: ConfigContainerChild,
  attributes?: FeatureAttribute[],
): PieChartData[] => {
  const colors = config?.options?.colors || FEATURE_CARD_DEFAULT_COLORS;

  const data: PieChartData[] = config?.children?.map(({ attributeName }, index) => {
    const attribute = attributes?.find(({ name }) => name === attributeName);

    return {
      name: attribute?.name || "",
      value: attribute ? Number(attribute.value) : 0,
      color: colors[index] || FEATURE_CARD_OTHER_COLOR,
    };
  });

  if (config?.options?.orderByValue) {
    data.sort((a, b) => (b.value as number) - (a.value as number));
  }

  const isOtherSliced = config?.options?.otherItems && config.options.otherItems < data.length;

  if (!isOtherSliced) return data;

  const otherValue = data
    .slice(0, config?.options?.otherItems)
    .reduce((prev, { value }) => prev + (value as number), 0);

  return [
    ...data?.slice(0, config.options?.otherItems),
    {
      name: i18n.t("classification.other", { ns: "common" }),
      color: FEATURE_CARD_OTHER_COLOR,
      value: Number(otherValue),
    },
  ];
};
